import React, { useEffect } from 'react';
import { Container } from '@/src/ui';

const NotFoundPage: React.FC = () => {
    useEffect(() => {
        document.title = '404 Not Found';
    }, []);

    return (
        <Container className="text-center flex flex-col justify-center min-h-screen">
            <h1>404 - Not Found</h1>
            <p>The page you are looking for does not exist.</p>
        </Container>
    );
};

export default NotFoundPage;
